import {RenderAugmentation} from "../types";
import {accountingTable} from "./accounting-table/augmentation";
import {stikkord} from "./stikkord/augmentation";
import {sectionIconLinks} from "./section-icon-links/augmentation";

export const augmentations: RenderAugmentation[] = [
    accountingTable,
    stikkord,
    sectionIconLinks,
];
